import { roleHasDealershipCapability } from "../models/dealershipCapabilities.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Staff inventory list + create / update / archive (capability-gated). */
export class StaffInventoryViewModel extends ViewModel {
    client;
    siteSlug;
    constructor(client, siteSlug) {
        super({ listings: [], loading: false, error: null });
        this.client = client;
        this.siteSlug = siteSlug;
    }
    canView() {
        const role = this.client.claims()?.role ?? "";
        return (roleHasDealershipCapability(role, "listings:write") ||
            roleHasDealershipCapability(role, "listings:archive"));
    }
    canWrite() {
        const role = this.client.claims()?.role ?? "";
        return roleHasDealershipCapability(role, "listings:write");
    }
    canArchive() {
        const role = this.client.claims()?.role ?? "";
        return roleHasDealershipCapability(role, "listings:archive");
    }
    async load() {
        if (!this.canView()) {
            this.setState({ listings: [], error: null });
            return;
        }
        await this.run(async () => {
            const listings = await this.client.listListings(this.siteSlug);
            this.setState({ listings });
        }, "Failed to load inventory.");
    }
    async create(input) {
        if (!this.canWrite())
            return false;
        const ok = await this.run(async () => {
            await this.client.createListing(this.siteSlug, input);
            await this.load();
            return true;
        }, "Failed to create listing.");
        return ok === true;
    }
    async update(id, input) {
        if (!this.canWrite())
            return false;
        const ok = await this.run(async () => {
            await this.client.updateListing(this.siteSlug, id, input);
            await this.load();
            return true;
        }, "Failed to update listing.");
        return ok === true;
    }
    async archive(id) {
        if (!this.canArchive())
            return false;
        const ok = await this.run(async () => {
            await this.client.archiveListing(this.siteSlug, id);
            await this.load();
            return true;
        }, "Failed to archive listing.");
        return ok === true;
    }
}
//# sourceMappingURL=StaffInventoryViewModel.js.map